// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__hdQNC","clinicsSelect":"TableHeading_clinicsSelect__bOY6M"};